import { render, staticRenderFns } from "./enterMirrorButton.vue?vue&type=template&id=0fc35e55&scoped=true"
import script from "./enterMirrorButton.vue?vue&type=script&lang=js"
export * from "./enterMirrorButton.vue?vue&type=script&lang=js"
import style0 from "./enterMirrorButton.vue?vue&type=style&index=0&id=0fc35e55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc35e55",
  null
  
)

export default component.exports